import React from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

export default function SelectorTienda({
  onChange, style, loading, size, defaultAll, permisoOtrasTiendas,
}) {
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  // TODO: Fixed mantener estado del seleccionable cuando saltamos de página.
  const storageOldTiendaId = sessionStorage.getItem('infoOldTiendaId');
  let oldTiendaId = null;
  if(storageOldTiendaId !== null) {
    const parseOldTiendaId = JSON.parse(storageOldTiendaId);
    oldTiendaId = parseOldTiendaId === -1 ? 'All' : parseOldTiendaId;
  } else {
    oldTiendaId = permisoOtrasTiendas ? 'All' : tiendaId;
  }
  
  const tiendas = useSelector(state => state.core.tiendas);
  const permisos = useSelector(state => state.auth.permisos);
  const onChangeSelect = (value) => {
    sessionStorage.setItem('infoOldTiendaId', value === 'All' ? -1 : value);
    onChange(value);
  }
  return (
    <Select
      disabled={!permisoOtrasTiendas}
      loading={loading}
      getPopupContainer={trigger => (trigger.parentElement
        ? trigger.parentElement : null)}
      defaultValue={oldTiendaId}
      style={style}
      size={size}
      showSearch
      className="selectStore"
      onChange={value => onChangeSelect(value)}
      optionFilterProp="label"
    >
      {permisoOtrasTiendas && <Select.Option value="All">Todas las tiendas</Select.Option>}
      {(() => tiendas.filter(e => permisoOtrasTiendas || e.id === tiendaId)
        .map(({ id, nombre }) => <Select.Option style={{ textTransform: 'capitalize' }} key={id} value={id} label={nombre.toLowerCase()}>{nombre.toLowerCase()}</Select.Option>))()}

    </Select>
  );
}
SelectorTienda.propTypes = {
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  defaultAll: PropTypes.bool,
  permisoOtrasTiendas: PropTypes.bool,
  size: PropTypes.string,
};
SelectorTienda.defaultProps = {
  onChange: () => {},
  loading: false,
  defaultAll: false,
  permisoOtrasTiendas: false,
  size: 'default',
};
